import CardsCount from './__card-count/lesson-meta__cards-count';
import Date from './__date/lesson-meta__date';
import Duration from './__duration/lesson-meta__duration';

export default {
    CardsCount,
    Date,
    Duration,
};
